export enum ActionStatus {
  DeviceError = -2,
  GeneralError = -1,
  Default = 0,
  Active = 1,
  UpdateRequired = 2,
  Expired = 3,
}
